import {Component, Inject, Input, OnInit} from '@angular/core';
import {ThemeService} from '@lv1871/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'lv-modal-dialog',
    templateUrl: './modal-dialog.component.html',
    styleUrls: ['./modal-dialog.component.scss'],
    standalone: false
})
export class ModalDialogComponent implements OnInit {


  constructor(public dialogRef: MatDialogRef<ModalDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { titel: string; content: string; bezAbbrechenButton: string; bezWeiterButton: string}
  ) {

  }

  ngOnInit(): void {
  }
  weiterButtonClicked(): void {
    this.dialogRef.close(true);
  }
  abbrechenButtonClicked(): void {
    this.dialogRef.close(false);
  }

}
